import React, { FC } from "react";
import { Stack, TextField, TextFieldProps } from "@mui/material";

type IScoringCommentPanel = TextFieldProps;

const ScoringCommentPanel: FC<IScoringCommentPanel> = (props) => {
    const { ...textFieldProps } = props;

    return (
        <Stack
            sx={{ flexGrow: 1, flexShrink: 0, minWidth: "60%", minHeight: "100px" }}
            spacing={2}
        >
            <TextField
                label="Write your feedback"
                multiline={true}
                sx={{
                    "&, .MuiInputBase-root, .MuiInputBase-input": {
                        height: "100% !important",
                    },
                    "textarea.MuiInputBase-input": {
                        overflow: "auto",
                    }
                }}
                {...textFieldProps}
            />
        </Stack>
    );
};

export default ScoringCommentPanel;
